module.exports = __webpack_public_path__ + "img/cancel.e0c28e8e.svg";